(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 20874:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(23158);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Button_Button; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/utils/environment/index.ts
var environment = __webpack_require__(98404);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(82227);
;// CONCATENATED MODULE: ./src/components/atoms/Button/Button.styles.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    border: 1px solid;\n    border-radius: 16px;\n    cursor: pointer;\n    display: block;\n    font-weight: ",
        ";\n    height: auto;\n    text-align: center;\n    text-decoration: none;\n    transition: background-color ",
        ", opacity ",
        ";\n    width: fit-content;\n    font-family: ",
        ";\n\n    span {\n      vertical-align: middle;\n    }\n\n    &:active {\n      opacity: 0.75;\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n    }\n\n    ",
        ";\n    ",
        ";\n    ",
        ";\n    ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var wrapperModifiers = {
    fullWidth: function() {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("width:100%;");
    },
    withIcon: function() {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("align-items:center;display:inline-flex;justify-content:center;svg{height:20px;width:20px;}svg + span{margin-left:10px;}");
    }
};
var variantModifiers = {
    primary: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("background-color:", theme.colors.brandColor1, ";border-color:", theme.colors.brandColor1, ";color:", theme.colors.white, ";&:hover{background-color:", theme.colors.brandColor1Darkened, ";border-color:", theme.colors.brandColor1Darkened, ";}&:disabled{background-color:", theme.colors.gray3, ";border-color:", theme.colors.gray3, ";color:", theme.colors.white, ";}");
    },
    secondary: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("background-color:", theme.colors.red, ";border-color:", theme.colors.red, ";color:", theme.colors.white, ";&:hover{background-color:", theme.colors.redDarkened, ";border-color:", theme.colors.redDarkened, ";}&:disabled{background-color:", theme.colors.gray3, ";border-color:", theme.colors.gray3, ";color:", theme.colors.white, ";}");
    },
    alternate: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("background-color:", theme.colors.white, ";border-color:", theme.colors.brandColor1, ";color:", theme.colors.brandColor1, ";&:hover{background-color:", theme.colors.brandColor1Light, ";}&:disabled{background-color:", theme.colors.gray1, ";border-color:", theme.colors.gray3, ";color:", theme.colors.gray3, ";}");
    },
    alternate2: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("background-color:", theme.colors.brandColor1Light, ";border-color:", theme.colors.brandColor1Light, ";color:", theme.colors.brandColor1, ";&:hover{filter:brightness(0.95);}&:disabled{background-color:", theme.colors.gray1, ";border-color:", theme.colors.gray1, ";color:", theme.colors.gray3, ";filter:brightness(1);}");
    }
};
var sizeModifiers = {
    small: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("padding:8px;font-size:", theme.font.sizes.xsmall, ";");
    },
    medium: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("padding:16px;font-size:", theme.font.sizes.small, ";");
    },
    large: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("padding:21px;font-size:", theme.font.sizes.small, ";");
    }
};
var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("button", {
    target: "ebjwbf90"
})(function(param) {
    var theme = param.theme, fullWidth = param.fullWidth, size = param.size, hasIcon = param.hasIcon, variant = param.variant;
    return (0,emotion_react_browser_esm.css)(_templateObject(), theme.font.weight.bold, theme.transition.default, theme.transition.default, theme.font.family.averta, !!fullWidth && wrapperModifiers.fullWidth(), hasIcon && wrapperModifiers.withIcon(), sizeModifiers[size](theme), variantModifiers[variant](theme));
});

;// CONCATENATED MODULE: ./src/components/atoms/Button/Button.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var Button = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _asLink = _param.asLink, asLink = _asLink === void 0 ? false : _asLink, _size = _param.size, size = _size === void 0 ? "medium" : _size, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, icon = _param.icon, props = _objectWithoutProperties(_param, [
        "children",
        "fullWidth",
        "asLink",
        "size",
        "variant",
        "icon"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Wrapper, _objectSpread({
        className: "ButtonStyles__Wrapper",
        fullWidth: fullWidth,
        size: size,
        variant: variant,
        hasIcon: !!icon,
        ref: ref
    }, asLink ? {
        as: "a"
    } : {}, props, {
        children: [
            icon,
            !!children && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                children: children
            })
        ]
    }));
});
if (environment/* isDevelopment */.y) {
    Button.displayName = "Button";
}
/* harmony default export */ var Button_Button = (Button);

;// CONCATENATED MODULE: ./src/components/atoms/Button/index.ts




/***/ }),

/***/ 15670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _src_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66817);


var useAuth = function() {
    var authContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_src_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_1__/* .AuthContext */ .Vo);
    return authContext;
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuth);


/***/ }),

/***/ 34328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Auth; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(82227);
;// CONCATENATED MODULE: ./src/components/molecules/AuthHeaderNav/AuthHeaderNav.styles.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    cursor: pointer;\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    white-space: nowrap;\n    width: 100%;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "et75v90"
})("align-content:center;display:flex;justify-content:space-between;width:100%;");
var Logo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("a", {
    target: "et75v91"
})("min-width:112px;width:auto;");
var AuthNav = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("nav", {
    target: "et75v92"
})("display:flex;gap:40px;align-items:center;");
var LinkLabel = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("a", {
    target: "et75v93"
})(function(param) {
    var theme = param.theme;
    return (0,emotion_react_browser_esm.css)(_templateObject(), theme.colors.gray4, theme.font.sizes.medium, theme.font.weight.normal);
});

;// CONCATENATED MODULE: ./src/components/molecules/AuthHeaderNav/AuthHeaderNav.tsx






var AuthHeaderNav = function() {
    var router = (0,next_router.useRouter)();
    var isLandingPage = /^\/$/.test(router.route);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_link["default"], {
                href: "/",
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Logo, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_image["default"], {
                        src: "/img/logo.svg",
                        alt: "Riiid for Classrooms logo",
                        width: 100,
                        height: 30,
                        placeholder: "blur",
                        blurDataURL: "/img/logo.svg"
                    })
                })
            }),
            isLandingPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(AuthNav, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_link["default"], {
                        href: "/signin",
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(LinkLabel, {
                            children: "Sign In"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_link["default"], {
                        href: "/signup",
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(LinkLabel, {
                            children: "Sign Up"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AuthHeaderNav_AuthHeaderNav = (AuthHeaderNav);

;// CONCATENATED MODULE: ./src/components/molecules/AuthHeaderNav/index.ts


;// CONCATENATED MODULE: ./src/layouts/Auth/styles.ts

var styles_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e703ikv0"
})("display:grid;grid-template-rows:auto 1fr;gap:40px;grid-gap:40px;padding:60px;width:100%;min-height:100vh;height:100%;");

;// CONCATENATED MODULE: ./src/layouts/Auth/index.tsx




var AuthLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(AuthHeaderNav_AuthHeaderNav, {}),
            children
        ]
    });
};
/* harmony default export */ var Auth = (AuthLayout);


/***/ }),

/***/ 23158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/layouts/Auth/index.tsx + 4 modules
var Auth = __webpack_require__(34328);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/templates/Auth/index.tsx + 1 modules
var templates_Auth = __webpack_require__(55571);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
// EXTERNAL MODULE: ./src/components/atoms/Button/index.ts + 2 modules
var Button = __webpack_require__(56042);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(82227);
;// CONCATENATED MODULE: ./src/components/molecules/LandingPageSection/LandingPageSection.styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    margin-bottom: 40px;\n    color: ",
        ";\n    font-size: 30px;\n    font-weight: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1udvmzy0"
})("padding:40px;width:360px;");
var Title = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("h1", {
    target: "e1udvmzy1"
})(function(param) {
    var theme = param.theme;
    return (0,emotion_react_browser_esm.css)(_templateObject(), theme.colors.gray8, theme.font.weight.normal);
});

;// CONCATENATED MODULE: ./src/components/molecules/LandingPageSection/LandingPageSection.tsx





var LandingPageSection = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Title, {
                children: "A platform that puts teachers first"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_link["default"], {
                passHref: true,
                href: "/signin",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                    fullWidth: true,
                    asLink: true,
                    children: "Get started"
                })
            })
        ]
    });
};
/* harmony default export */ var LandingPageSection_LandingPageSection = (LandingPageSection);

;// CONCATENATED MODULE: ./src/components/molecules/LandingPageSection/index.ts


// EXTERNAL MODULE: ./src/hooks/useAuth.tsx
var useAuth = __webpack_require__(15670);
;// CONCATENATED MODULE: ./public/img/illustrations/home.svg
/* harmony default export */ var home = ({"src":"/_next/static/media/home.c2378836.svg","height":611,"width":692});
;// CONCATENATED MODULE: ./src/templates/Home/index.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}







var HomeTemplate = function() {
    var ref = (0,useAuth/* default */.Z)(), loadUserWhenHomePageMounted = ref.loadUserWhenHomePageMounted, logOut = ref.logOut;
    var checkAuthentication = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return loadUserWhenHomePageMounted();
                case 3:
                    _ctx.next = 9;
                    break;
                case 5:
                    _ctx.prev = 5;
                    _ctx.t0 = _ctx["catch"](0);
                    console.warn(_ctx.t0);
                    logOut();
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                5
            ]
        ]);
    })), [
        loadUserWhenHomePageMounted,
        logOut
    ]);
    (0,react.useEffect)(function() {
        checkAuthentication();
    }, [
        checkAuthentication
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(templates_Auth/* default */.Z, {
        illustrationSrc: home,
        illustrationAlt: "A teacher working on her computer with a whiteboard with charts on it behind her.",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(LandingPageSection_LandingPageSection, {})
    });
};
/* harmony default export */ var Home = (HomeTemplate);

;// CONCATENATED MODULE: ./src/pages/index.page.tsx




var Homepage = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Home, {});
};
Homepage.layout = Auth/* default */.Z;
/* harmony default export */ var index_page = (Homepage);


/***/ }),

/***/ 55571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Auth; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(82227);
;// CONCATENATED MODULE: ./src/templates/Auth/styles.ts

var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("main", {
    target: "e13yas810"
})("display:flex;justify-content:space-between;align-items:center;padding:0 70px;height:100%;");
var IllustrationWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e13yas811"
})("display:flex;justify-content:right;height:610px;");

;// CONCATENATED MODULE: ./src/templates/Auth/index.tsx




var AuthTemplate = function(param) {
    var illustrationSrc = param.illustrationSrc, illustrationAlt = param.illustrationAlt, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Wrapper, {
        children: [
            children,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(IllustrationWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_image["default"], {
                    src: illustrationSrc,
                    alt: illustrationAlt
                })
            })
        ]
    });
};
/* harmony default export */ var Auth = (AuthTemplate);


/***/ }),

/***/ 98404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ isDevelopment; }
/* harmony export */ });
var isDevelopment = "production" !== "production";


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [237,774,888,179], function() { return __webpack_exec__(20874); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);